module.exports = __webpack_public_path__ + "img/envelope.318b5bd1.svg";